/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import { DN40A, DN50A, DN60A, N40A, N50A, N60A } from './colors';
import themed from './utils/themed';

/**
 * __e100__
 *
 * Eg. Cards on a board.
 *
 * @deprecated use `token('elevation.shadow.raised')` instead.
 */
export var e100 = themed({
  light: "box-shadow: ".concat("var(--ds-shadow-raised, ".concat("0 1px 1px ".concat(N50A, ", 0 0 1px 1px ").concat(N40A), ")"), ";"),
  dark: "box-shadow: ".concat("var(--ds-shadow-raised, ".concat("0 1px 1px ".concat(DN50A, ", 0 0 1px 1px ").concat(DN40A), ")"), ";")
});

/**
 * __e200__
 *
 * Eg. Inline dialogs.
 *
 * @deprecated use `token('elevation.shadow.overlay')` instead.
 */
export var e200 = themed({
  light: "box-shadow: ".concat("var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat(N50A, ", 0 0 1px ").concat(N60A), ")"), ";"),
  dark: "box-shadow: ".concat("var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat(DN50A, ", 0 0 1px ").concat(DN60A), ")"), ";")
});

/**
 * __e300__
 *
 * Eg. Modals.
 *
 * @deprecated use `token('elevation.shadow.overlay')` instead.
 */
export var e300 = themed({
  light: "box-shadow: ".concat("var(--ds-shadow-overlay, ".concat("0 8px 16px -4px ".concat(N50A, ", 0 0 1px ").concat(N60A), ")"), ";"),
  dark: "box-shadow: ".concat("var(--ds-shadow-overlay, ".concat("0 8px 16px -4px ".concat(DN50A, ", 0 0 1px ").concat(DN60A), ")"), ";")
});

/**
 * __e400__
 *
 * Eg. Panels.
 *
 * @deprecated use `token('elevation.shadow.overlay')` instead.
 */
export var e400 = themed({
  light: "box-shadow: ".concat("var(--ds-shadow-overlay, ".concat("0 12px 24px -6px ".concat(N50A, ", 0 0 1px ").concat(N60A), ")"), ";"),
  dark: "box-shadow: ".concat("var(--ds-shadow-overlay, ".concat("0 12px 24px -6px ".concat(DN50A, ", 0 0 1px ").concat(DN60A), ")"), ";")
});

/**
 * __e500__
 *
 * Eg. Flags.
 *
 * @deprecated use `token('elevation.shadow.overlay')` instead.
 */
export var e500 = themed({
  light: "box-shadow: ".concat("var(--ds-shadow-overlay, ".concat("0 20px 32px -8px ".concat(N50A, ", 0 0 1px ").concat(N60A), ")"), ";"),
  dark: "box-shadow: ".concat("var(--ds-shadow-overlay, ".concat("0 20px 32px -8px ".concat(DN50A, ", 0 0 1px ").concat(DN60A), ")"), ";")
});